export default ({ type, isReplacing }) => {
  const TITLE_MAPPING = {
    live: {
      add: 'add-video-trailer',
      replace: 'replace-trailer',
    },
    'on-demand': {
      add: 'add-video',
      replace: 'replace-video',
    },
  };

  return TITLE_MAPPING[type][isReplacing ? 'replace' : 'add'];
};
